<template>
  <el-dialog :title="'添加区域'" :visible.sync="formVisible" :close-on-click-modal="false" width="1000px">
    <el-form ref="dataForm" label-position="right" :rules="formRules" :model="form" size="small" label-width="130px">

      <el-form-item label="管辖区域：" prop="cityCompanyAddrAreaList" class="width100">
        <el-cascader v-model="form.cityCompanyAddrAreaList" :props="cascaderProps1" collapse-tags :options="technicianAreOptions" clearable popper-class="cascader-box"></el-cascader>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import cityCompanyApi from '@/api/sys/cityCompany'
import courseSubjectBarrierStudentApi from '@/api/course/courseSubjectBarrierStudent'
import CityCompanyAddrAreaApi from '@/api/sys/CityCompanyAddrArea'
function initFormBean() {
  const formBean = {
    cityCompanyAddrAreaList: []
  }
  return formBean
}

export default {
  props: {
    addressList: Array
  },
  data() {
    return {
      form: initFormBean(),
      isLoading: false,
      formVisible: false,
      selectItems: [],
      formRules: {
        cityCompanyAddrAreaList: [{
          required: true,
          message: '请选择管辖区域',
          trigger: 'change'
        }]
      },
      cascaderProps1: {
        label: 'areaName',
        value: 'areaCode',
        children: 'child',
        multiple: true
      },
      technicianAreOptions: []

    }
  },
  created() {

  },
  methods: {
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    getCityCompanyTreeList() {
      CityCompanyAddrAreaApi.CityCompanyTreeList().then(res => {
        this.technicianAreOptions = this.formatCascaderData(res.data);
      })
    },
    resetForm() {
      this.form = initFormBean()
    },
    handleCreate(row) {
      this.getCityCompanyTreeList()
      this.resetForm()
      this.formVisible = true
      this.rowItem = { ...row }
      this.$nextTick(async () => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let params = { ...this.form }
          params.cityCompanyAddrAreaList = params.cityCompanyAddrAreaList && params.cityCompanyAddrAreaList.length > 0 ? params.cityCompanyAddrAreaList.map(i => {
            return { provinceCode: i[0], cityCode: i[1], districtCode: i[2], areaType: 3, cityCompanyId: this.rowItem.id }
          }) : null
          this.isLoading = true
          CityCompanyAddrAreaApi.saveAddrAreaBatch(params.cityCompanyAddrAreaList).then((data) => {
            this.postCallback(data)
          }).catch(res => {
            this.isLoading = false
          });
        }
      });
    },
    postCallback(data) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
      this.isLoading = false
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}

::v-deep .el-input {
  width: 100%;
}

.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
</style>
